import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import { Box, Button, CircularProgress, FormControl, FormGroup, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getDeleteModalStyles } from '../../SiteManagement/styles';
import { Environments } from "@beable/roster-backend-client-v1";
import ssoManagementService from "../../../services/SSOManagementService";
import EnvironmentSelector from '../../Common/Selectors/EnvironmentSelector';

interface LTIConfigModalProps {
  open: boolean;
  handleClose: any;
}

export default function LTIConfigModal(props: LTIConfigModalProps) {
  const theme = useTheme();
  const styles = getDeleteModalStyles(theme);
  const [isLoading, setIsLoading] = useState(false);
  const [copySucceeded, setCopySucceeded] = useState(false);
  const [copyActivated, setCopyActivated] = useState(false);
  const [env, setEnv] = useState(Environments.qa);
  const [json, setJson] = useState<null | string>(null);

  const getLTIConfigJSON = async () => {
    try {
      setIsLoading(true);
      const result = await ssoManagementService.getLTIConfig(env);

      if(result && result.config) {
        const { config } = result;
        const json = JSON.stringify(config, null, 2);
        setJson(json);
        await navigator.clipboard.writeText(json);
        setCopySucceeded(true);
      }
    } catch (e) {
      setCopySucceeded(false);
    } finally {
      setIsLoading(false);
      setCopyActivated(true);
    }
  }


  const resetState = () => {
    setIsLoading(false);
    setCopySucceeded(false);
    setCopyActivated(false);
    setEnv(Environments.qa);
    setJson(null);
  };

  const handleClose = () => {
    const success = copySucceeded;
    resetState();
    props.handleClose(success);
  }

  return (
    <Modal
      aria-labelledby="lticonfig-modal-title"
      aria-describedby="lticonfig-modal-description"
      open={props.open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          props.handleClose();
        }
      }}
    >
      <Box component="div" sx={[styles.paper, styles.deleteModal]}>
        <h2 id="delete-modal-title">Choose environment:</h2>
        <FormControl variant="standard" margin="dense" sx={styles.dflex}>
          <EnvironmentSelector
            env={env}
            onChange={(e: any) => setEnv(e.target.value as Environments)}
          />
        </FormControl>
        <FormGroup sx={[styles.mt2, styles.dfr]}>
          {isLoading ? <CircularProgress color="primary" /> : undefined}
          {json && (
            <Box component="pre" sx={styles.code} data-testid="copied-json">
              {json}
            </Box>
          )}
          {copySucceeded && copyActivated ? <Typography sx={styles.greenTxt}>Successfully copied</Typography> : undefined}
          {!copySucceeded && copyActivated ? <Typography sx={styles.redTxt}>Unable to copy</Typography> : undefined}
        </FormGroup>
        <FormGroup sx={[styles.mt2, styles.dfr]}>
          <Button variant="contained" disabled={copyActivated && copySucceeded} sx={styles.btnGreen} onClick={getLTIConfigJSON}>Generate and copy</Button>
          <Button variant="contained" onClick={handleClose} sx={styles.ml2}>Close</Button>
        </FormGroup>
      </Box>
    </Modal>
  );
}